(function () {
  'use strict';

  var OPEN_KEY = 'cdc:open';

  function root() {
    return document.querySelector('[data-cdc]');
  }

  function msg(name, fallback) {
    var el = root();
    return (el && el.getAttribute(name)) || fallback;
  }

  function q(sel) {
    var el = root();
    return el ? el.querySelector(sel) : null;
  }


  function setOpen(open) {
    var sheet = q('[data-cdc-sheet]');
    var back = q('[data-cdc-backdrop]');
    if (!sheet || !back) return;

    sheet.hidden = !open;
    back.hidden = !open;
    document.documentElement.classList.toggle('cdc-open', open);

    if (open) {
      var input = q('[data-cdc-input]');
      if (input) setTimeout(function () { input.focus(); }, 60);
    } else {
      clearMsg();
    }
  }

  function clearMsg() {
    var m = q('[data-cdc-msg]');
    var input = q('[data-cdc-input]');
    if (m) { m.hidden = true; m.textContent = ''; m.className = 'cdc__msg'; }
    if (input) input.classList.remove('is--err');
  }

  function showMsg(text, kind) {
    var m = q('[data-cdc-msg]');
    var input = q('[data-cdc-input]');
    if (input) input.classList.toggle('is--err', kind === 'err');
    if (!m) return;
    m.textContent = text;
    m.className = 'cdc__msg is--' + (kind || 'note');
    m.hidden = false;
  }


  function getCart() {
    return fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function appliedCodes(cart) {
    var out = [];
    (cart.discount_codes || []).forEach(function (d) {
      if (d && d.code && d.applicable !== false) out.push(d.code);
    });
    if (out.length) return out;
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      if (d.type === 'discount_code' && d.title) out.push(d.title);
    });
    return out;
  }

  function titleOnCart(cart, want) {
    function hit(d) {
      return d && (d.title || '').toUpperCase() === want;
    }
    if ((cart.cart_level_discount_applications || []).some(hit)) return true;
    return (cart.items || []).some(function (item) {
      if ((item.discounts || []).some(hit)) return true;
      return (item.line_level_discount_allocations || []).some(function (a) {
        return hit(a && a.discount_application);
      });
    });
  }

  function isApplied(cart, want) {
    var echoed = (cart.discount_codes || []).filter(function (d) {
      return (d.code || '').toUpperCase() === want;
    })[0];
    if (echoed) return { known: true, ok: echoed.applicable === true };
    return { known: titleOnCart(cart, want), ok: titleOnCart(cart, want) };
  }


  function renderChips(cart) {
    var list = document.querySelector('[data-cdc-chips]');
    if (!list) return;

    var codes = [];
    (cart.discount_codes || []).forEach(function (d) {
      if (d && d.code && d.applicable === true) codes.push(d.code);
    });
    if (!codes.length) {
      (cart.cart_level_discount_applications || []).forEach(function (d) {
        if (d.type === 'discount_code' && d.title) codes.push(d.title);
      });
    }

    var row = document.querySelector('[data-cdc-applied]');
    list.innerHTML = '';
    if (!codes.length) {
      list.hidden = true;
      if (row) row.hidden = true;
      return;
    }
    if (row) row.hidden = false;

    codes.forEach(function (code) {
      var li = document.createElement('li');
      li.className = 'cdc__chip';
      li.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
        '<path d="M12.6 3.4 20 10.8a2 2 0 0 1 0 2.8l-6.4 6.4a2 2 0 0 1-2.8 0L3.4 12.6A2 2 0 0 1 2.8 11V5a2 2 0 0 1 2-2h6a2 2 0 0 1 1.6.4Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>' +
        '<circle cx="7.6" cy="7.6" r="1.4" fill="currentColor"/></svg>' +
        '<span>' + code + '</span>' +
        '<button type="button" class="cdc__chipx" data-cdc-remove="' + code + '" aria-label="Remove ' + code + '">' +
        '<svg viewBox="0 0 24 24" fill="none"><path d="M18 6 6 18M6 6l12 12" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>' +
        '</button>';
      list.appendChild(li);
    });
    list.hidden = false;
  }


  function postCodes(list) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: list.join(',') })
    }).then(function (r) { return r.json(); });
  }

  function refreshDrawer() {
    var drawer = document.querySelector('cart-drawer');
    return fetch('/?sections=cart-drawer,cart-icon-bubble,cart-icon-quick', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (sections['cart-drawer'] && drawer) {
          var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var fresh = doc.querySelector('#CartDrawer');
          var live = document.querySelector('#CartDrawer');
          if (fresh && live) live.innerHTML = fresh.innerHTML;
        }
        ['cart-icon-bubble', 'cart-icon-quick'].forEach(function (id) {
          if (!sections[id]) return;
          var target = document.getElementById('shopify-section-' + id);
          if (!target) return;
          var d = new DOMParser().parseFromString(sections[id], 'text/html');
          var s = d.querySelector('.shopify-section');
          if (s) target.innerHTML = s.innerHTML;
        });
      })
      .catch(function () {});
  }

  function apply(code) {
    code = (code || '').trim();
    if (!code) {
      showMsg(msg('data-msg-empty', 'Enter a discount code first.'), 'err');
      return;
    }

    var want = code.toUpperCase();
    var btn = q('[data-cdc-apply]');
    if (btn) { btn.disabled = true; btn.classList.add('is--busy'); }
    clearMsg();

    getCart()
      .then(function (cart) {
        if (titleOnCart(cart, want)) {
          showMsg(msg('data-msg-already', 'This discount is already applied to your cart.'), 'note');
          return null;
        }
        var list = appliedCodes(cart);
        if (list.map(function (c) { return c.toUpperCase(); }).indexOf(want) === -1) list.push(code);
        return postCodes(list);
      })
      .then(function (cart) {
        if (!cart) return;
        var state = isApplied(cart, want);

        if (state.ok) {
          var input = q('[data-cdc-input]');
          if (input) input.value = '';
          showMsg('"' + want + '" applied.', 'ok');
          renderChips(cart);
          sessionStorage.setItem(OPEN_KEY, '1');
          return refreshDrawer().then(function () {
            setTimeout(function () { setOpen(false); }, 900);
          });
        }

        showMsg(
          state.known
            ? msg('data-msg-notapply', 'This code does not apply on the items in cart.')
            : msg('data-msg-invalid', 'The code you entered is invalid. Please double-check the code and try again.'),
          'err'
        );
      })
      .catch(function () {
        showMsg(msg('data-msg-error', 'Something went wrong. Please try again.'), 'err');
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('is--busy'); }
      });
  }

  function remove(code) {
    var want = (code || '').toUpperCase();
    getCart()
      .then(function (cart) {
        var list = appliedCodes(cart).filter(function (c) {
          return c.toUpperCase() !== want;
        });
        return postCodes(list);
      })
      .then(function (cart) {
        renderChips(cart);
        return refreshDrawer();
      })
      .catch(function () {});
  }


  var bootBusy = null;
  var bootTimer = null;

  function boot() {
    if (!root()) return;
    if (bootBusy) return;
    var chips = document.querySelector('[data-cdc-chips]');
    if (chips) chips.setAttribute('data-cdc-seen', '');
    bootBusy = getCart().then(renderChips).catch(function () {}).then(function () {
      bootBusy = null;
    });
  }

  function scheduleBoot() {
    clearTimeout(bootTimer);
    bootTimer = setTimeout(boot, 200);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    if (t.closest('[data-cdc-open]')) { e.preventDefault(); setOpen(true); return; }
    if (t.closest('[data-cdc-close]') || t.closest('[data-cdc-backdrop]')) { e.preventDefault(); setOpen(false); return; }
    if (t.closest('[data-cdc-apply]')) {
      e.preventDefault();
      var input = q('[data-cdc-input]');
      apply(input ? input.value : '');
      return;
    }
    var rm = t.closest('[data-cdc-remove]');
    if (rm) { e.preventDefault(); remove(rm.getAttribute('data-cdc-remove')); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.documentElement.classList.contains('cdc-open')) {
      setOpen(false);
      e.stopPropagation();
    }
    if (e.key === 'Enter' && e.target && e.target.matches('[data-cdc-input]')) {
      e.preventDefault();
      apply(e.target.value);
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches('[data-cdc-input]')) clearMsg();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('cart:refresh', boot);
  new MutationObserver(function () {
    var chips = document.querySelector('[data-cdc-chips]');
    if (root() && chips && !chips.hasAttribute('data-cdc-seen')) {
      chips.setAttribute('data-cdc-seen', '');
      scheduleBoot();
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
